import { DateInterval } from '~/DateTime';
import Price from '~/libs/Price/Price';
import { ProductPrice } from '~/Product';

import ProductPriceHistoryRecord from './ProductPriceHistoryRecord';

export default function mapProductPriceHistoryRecord(record: {
	value: string;
	currency: string;
	until: number;
	since: number;
	type: string;
}) {
	return new ProductPriceHistoryRecord(
		new ProductPrice(record.type, new Price(record.value, record.currency), 0),
		new DateInterval(new Date(record.since), record.until !== null ? new Date(record.until) : null)
	);
}
